import { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { take } from 'lodash'
import { fetchGifsFromUrl } from 'shared/redux/fetch-gifs'
import { getGifs, getResponseId } from '../../shared/reducers'
import { processTrendingAPIGifs } from 'shared/util/gif-process'
import appendQuery from 'append-query'
import GifPropType from 'shared/prop-types/gif'
import SharedSectionHeader, { SectionHeaderWithSeeAll } from 'shared/components/section-header'
import styled from 'styled-components'
import { withRouter } from 'react-router'
import ScrollCarousel from 'shared/components/scroll-carousel'
import { relativeUrl } from 'shared/util/url'
import { MOBILE_API_KEY, API_URL } from 'shared/api'
import urlHelper from 'url'

const MAX_GIF_COUNT = 50

const SectionHeader = styled(SharedSectionHeader)`
    margin-top: 20px;
`

@withRouter
@connect(
    state => ({
        gifs: take(getGifs(state, 'trending'), MAX_GIF_COUNT),
        responseId: getResponseId(state, `trending`),
    }),
    { fetchGifsFromUrl }
)
export default class TrendingStories extends PureComponent {
    static propTypes = {
        pingback_id: PropTypes.string,
        fetchGifsFromUrl: PropTypes.func.isRequired,
        gifs: PropTypes.arrayOf(GifPropType),
        responseId: PropTypes.string,
        headerText: PropTypes.string,
        hideSeeAll: PropTypes.bool,
        marginBottom: PropTypes.number,
        isInDropdown: PropTypes.bool,
        onGifSelected: PropTypes.func,
        limit: PropTypes.number,
    }
    componentDidMount() {
        const { fetchGifsFromUrl, pingbackId, limit = 25 } = this.props
        const {
            query: { moatqa },
        } = urlHelper.parse(location.search, true)
        const url = appendQuery(`${API_URL}${moatqa ? `gifs/search` : `gifs/trending`}`, {
            api_key: MOBILE_API_KEY,
            limit,
            q: `${moatqa || ''}`,
            pingback_id: pingbackId,
        })
        fetchGifsFromUrl(url, {
            groupId: `trending`,
            report: false,
            processor: processTrendingAPIGifs,
            pingback_id: pingbackId,
            apiKey: MOBILE_API_KEY,
        })
    }
    onClick = path => {
        location.href = path
    }
    onGifClick = (e, { url }) => {
        const { history, onGifSelected } = this.props
        e.preventDefault()
        onGifSelected && onGifSelected()
        history.push(relativeUrl(url))
    }
    render() {
        const { gifs, responseId, hideSeeAll, headerText, marginBottom = 30, isInDropdown, pingbackId } = this.props
        const headerLabel = headerText || 'Trending GIFs'
        const headerUrl = '/trending-gifs'
        const historyState = { pingback_id: pingbackId }
        return (
            <>
                {hideSeeAll ? (
                    <SectionHeader label={headerLabel} url={headerUrl} isHistoryPush historyState={historyState} />
                ) : (
                    <SectionHeaderWithSeeAll
                        label={headerLabel}
                        url={headerUrl}
                        isHistoryPush
                        historyState={historyState}
                    />
                )}
                <ScrollCarousel
                    gifs={gifs}
                    height={120}
                    rendition={`fixed_width`}
                    showTags={false}
                    hideLock={true}
                    onClick={this.onGifClick}
                    responseId={responseId}
                    marginBottom={marginBottom}
                    isTracking
                    isInDropdown={isInDropdown}
                />
            </>
        )
    }
}
